<template>
  <div class="container my-4">
    <!-- Banner -->
    <div class="row mb-2">
      <div class="col-12">
       
        <img src="/images/head_banner.jpg" alt="Loan Banner" class="img-fluid w-100 rounded" />
       
      </div>
    </div>

    <div class="row">
      <!-- Left Content -->
      <div class="col-xl-9 col-lg-9 col-md-8 col-sm-12">
        <div class="card mb-4 shadow-sm">
          <div class="card-header text-white" style="background-color: #ae275f;">
            <h2 class="card-title m-0">
              Pata Mkopo <small class="text-light">Chapu Chapu</small>
            </h2>
          </div>
          <div class="card-body">
            <!-- Search -->
            <input
              v-model="search"
              @input="debounceFilter"
              type="text"
              placeholder="Tafuta mkopo..."
              class="form-control mb-4"
            />

            <!-- Loans List -->
            <transition-group name="fade" tag="div">
              <LoanItem
                v-for="(loan, index) in filteredLoans"
                :key="index"
                :loan="loan"
              />
            </transition-group>
            <img :src="`${publicPath}images/loan_types.png`" alt="Customer Banner" class="img-fluid mt-2"/>
            <!-- Empty state -->
            <div v-if="!filteredLoans.length" class="text-muted mt-4">
              Hakuna mkopo unaolingana na tafuta lako.
            </div>

            <!-- FAQs -->
            <h4 class="mt-5">Maswali Yanayoulizwa Mara kwa Mara</h4>
            <FaqItem
              v-for="(faq, i) in faqs"
              :key="i"
              :faq="faq"
              :index="i"
            />

            <!-- Testimonial -->
            <div class="card mt-5 bg-light border-0 shadow-sm">
              <div class="card-body text-center">
                <transition name="fade" mode="out-in">
                  <blockquote class="blockquote mb-0" :key="currentTestimonial">
                    <p>"{{ testimonials[currentTestimonial].text }}"</p>
                    <footer class="blockquote-footer">
                      {{ testimonials[currentTestimonial].author }}
                    </footer>
                  </blockquote>
                </transition>
              </div>
            </div>
            <img :src="`${publicPath}images/women_4.jpg`" alt="Customer Banner" class="img-fluid" />
            
            <!-- CTA -->
            <div class="alert mt-4 text-center text-white" style="background-color: #ae275f;">
              Una swali?
              <router-link to="/contact" class="btn btn-outline-dark ms-2">
                Wasiliana Nasi
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Panel -->
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12">
        <div class="card mb-3 shadow-sm">
          <div class="card-header text-white" style="background-color: #ae275f;">
            <h2 class="card-title m-0">Karibu <small class="text-muted text-white">Tukuhudumie</small></h2>
          </div>
          <div class="card-body text-center">
            <img :src="`${publicPath}images/women_3.png`" alt="Customer Banner" class="img-fluid rounded mb-3" />
            <router-link to="/contact" class="btn btn-secondary w-100">
              Maoni/Malalamiko <i class="fa fa-arrow-circle-right"></i>
            </router-link>
            <img :src="`${publicPath}images/women_1.jpg`" alt="Customer Banner" class="img-fluid rounded mt-3" />
            <img :src="`${publicPath}images/woman_1.jpg`" alt="Customer Banner" class="img-fluid rounded mt-3" />
            <img :src="`${publicPath}images/women_2.jpg`" alt="Customer Banner" class="img-fluid rounded mt-3" />
          </div>
          
        </div>
      </div>
    </div>

    <!-- Floating Apply Button -->
    <router-link to="/loan-application" class="floating-btn" title="Omba Mkopo" aria-label="Omba Mkopo">
      <i class="fa fa-plus"></i>
    </router-link>
  </div>
</template>

<script>
import LoanItem from './LoanItem.vue'
import FaqItem from './FaqItem.vue'

export default {
  name: 'HomePage',
  components: {
    LoanItem,
    FaqItem,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      search: '',
      loans: [
        {
          type: "Group Loan (Mkopo wa Vikundi)",
          requirements: ["Lazima uwe na biashara", "Lazima uwe na kikundi"]
        },
        {
          type: "Individual Loan (Mtu Mmoja)",
          requirements: ["Lazima uwe na biashara", "Lazima uwe na dhamana"]
        },
        {
          type: "Mkopo wa Dharura kwa Waajiriwa",
          requirements: [
            "Lazima uwe umeajiriwa",
            "Lazima mwajiri wako awe mdhamini",
            "Dhamana sio lazima"
          ]
        }
      ],
      faqs: [
        {
          question: "Nani anaruhusiwa kuomba mkopo?",
          answer: "Mkopo unaweza kutolewa kwa mtu binafsi, vikundi, au waajiriwa walio na mdhamini."
        },
        {
          question: "Je, kuna viwango maalum vya riba?",
          answer: "Ndiyo, viwango vya riba hutegemea aina ya mkopo na mteja. Tafadhali wasiliana nasi kwa maelezo zaidi."
        }
      ],
      filteredLoans: [],
      debounceTimeout: null,
      testimonials: [
        {
          text: "Nilipata mkopo wa dharura haraka sana. Asante sana!",
          author: "Asha M., Dar es Salaam"
        },
        {
          text: "Huduma zao ni za haraka na za kuaminika!",
          author: "Juma K., Arusha"
        }
      ],
      currentTestimonial: 0
    };
  },
  created() {
    this.filteredLoans = this.loans;
    this.rotateTestimonials();
  },
  methods: {
    debounceFilter() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        const query = this.search.toLowerCase();
        this.filteredLoans = this.loans.filter(loan =>
          loan.type.toLowerCase().includes(query)
        );
      }, 300);
    },
    rotateTestimonials() {
      setInterval(() => {
        this.currentTestimonial = (this.currentTestimonial + 1) % this.testimonials.length;
      }, 5000);
    }
  }
};
</script>

<style scoped>
.floating-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background-color: #ae275f;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  text-decoration: none;
  z-index: 1000;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}
.floating-btn:hover {
  background-color: rgba(0, 0, 255, 0.61);
  color: white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
